export default __webpack_public_path__ + "static/media/reviewersOnDoc.ba6dec8a.png";